import { Directive, Input, Injector } from '@angular/core';
import { FrameContext, BindingData, ViewModel } from '@farris/devkit';
@Directive({
    selector: '[farrisSort]'
})
export class FarrisSortDirective {

}

@Directive({
    selector: '[farris-textarea-edit]'
})
export class FarrisTextareaEditDirective {

}

@Directive({
    selector: '[farrisDynamicColumnFormat]'
})
export class FarrisDynamicColumnFormatDirective {

}

@Directive({
    selector: '[farris-enter-edit]'
})
export class FarrisEditEnterDirective {
    @Input('form-group') farrisForm: any;
}

@Directive({
    selector: '[farrisTreeTableFormat]'
})
export class FarrisTreeTableFormatDirective {

}

